import React, { useState } from "react";
import { MobileUnderCalAds } from "../../Ads";
const ResistanceCalculator = () => {
  const [length, setLength] = useState("");
  const [lengthUnit, setLengthUnit] = useState("meters");
  const [diameter, setDiameter] = useState("");
  const [diameterUnit, setDiameterUnit] = useState("centimeter");
  const [conductivity, setConductivity] = useState(59600000);
  const [material, setMaterial] = useState("Copper");
  const [resistance, setResistance] = useState(null);
  const [error, setError] = useState("");
  const materialConductivity = {
    Silver: 63000000,
    Copper: 59600000,
    "Annealed copper": 58800000,
    Gold: 45200000,
    Aluminum: 37200000,
  };
  const handleCalculate = () => {
    try {
      const lengthValue = parseFloat(length);
      const diameterValue = parseFloat(diameter);
      const selectedConductivity =
        materialConductivity[material] || parseFloat(conductivity);
      if (
        isNaN(lengthValue) ||
        lengthValue <= 0 ||
        isNaN(diameterValue) ||
        diameterValue <= 0
      ) {
        throw new Error("الرجاء إدخال قيم صحيحة.");
      }
      const lengthInMeters = convertToMeters(lengthValue, lengthUnit);
      const diameterInMeters = convertToMeters(diameterValue, diameterUnit);
      const area = Math.PI * Math.pow(diameterInMeters / 2, 2);
      const resistanceValue = lengthInMeters / (selectedConductivity * area);
      setResistance(resistanceValue.toFixed(6));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  const convertToMeters = (value, unit) => {
    const unitConversion = {
      meters: 1,
      yards: 0.9144,
      feet: 0.3048,
      inches: 0.0254,
      miles: 1609.34,
      km: 1000,
      cm: 0.01,
      mm: 0.001,
    };
    return value * unitConversion[unit];
  };
  return (
    <div className="rtl">
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة مقاومة الموصل</h2>
                </div>
                <div className="row">
                  <div>
                    <p>الرجاء إدخال طول وقطر وموصلية الموصل لحساب مقاومته.</p>
                    <p>
                      يمكنك أيضًا اختيار مادة شائعة للحصول على الموصلية الافتراضية.
                    </p>
                    <u><p>المواد الشائعة وموصلياتها (S/m):</p></u>
                    <ul>
                      <li>الفضة: 63,000,000</li>
                      <li>النحاس: 59,600,000</li>
                      <li>النحاس المملس: 58,800,000</li>
                      <li>الذهب: 45,200,000</li>
                      <li>الألمنيوم: 37,200,000</li>
                    </ul>
                  </div>
                </div>
                <MobileUnderCalAds />
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="lengthSelect" className="form-label ms-2">
                          أدخل الطول
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="100"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <select
                        id="lengthSelect"
                        value={lengthUnit}
                        onChange={(e) => setLengthUnit(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "90%" }}
                      >
                        <option value="meters">متر</option>
                        <option value="yards">ياردة</option>
                        <option value="feet">قدم</option>
                        <option value="inches">بوصة</option>
                        <option value="miles">ميل</option>
                        <option value="km">كم</option>
                        <option value="cm">سم</option>
                        <option value="mm">ملم</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="diameterSelect" className="form-label ms-2">
                          أدخل القطر
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="0.05"
                        value={diameter}
                        onChange={(e) => setDiameter(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <select
                        id="diameterSelect"
                        value={diameterUnit}
                        onChange={(e) => setDiameterUnit(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "90%" }}
                      >
                        <option value="meters">متر</option>
                        <option value="yards">ياردة</option>
                        <option value="feet">قدم</option>
                        <option value="inches">بوصة</option>
                        <option value="km">كم</option>
                        <option value="cm">سم</option>
                        <option value="mm">ملم</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الموصلية</label>
                      </b>
                      <input
                        type="text"
                        placeholder="59600000"
                        value={conductivity}
                        onChange={(e) => setConductivity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">S/m</span>
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <label htmlFor="materialSelect" className="ms-2">
                        <b> ,أو اختر المادة</b>
                      </label>
                      <select
                        id="materialSelect"
                        value={material}
                        onChange={(e) => setMaterial(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "75%" }}
                      >
                        <option value="Copper">نحاس</option>
                        <option value="Silver">فضة</option>
                        <option value="Annealed copper">نحاس مملس</option>
                        <option value="Gold">ذهب</option>
                        <option value="Aluminum">ألمنيوم</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      resistance && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">المقاومة: {resistance} Ω</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResistanceCalculator;
